import React, { useContext, useState } from "react";
import { useEffect } from "react";
import { CiLocationOn } from "react-icons/ci";
import { NavLink } from "react-router-dom";
import { server } from "../../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../../store/stateFunctions";
import useQuickLook from "../../../quicklook/useQuickLook";
import { AiFillDelete } from "react-icons/ai";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import configContext from "../../../context/configContext/configContext";

const swalalert = withReactContent(Swal);

const StudentInternshipApplications = () => {
  const user = useSelectAccess("Student");
  const [data, setData] = useState([]);
  const [yuvadata, setYuvaData] = useState([]);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);
  const displayFile = useQuickLook();

  useEffect(() => {
    getData();
    getYuvaData();
  }, []);

  const getData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/internship/studentapplications", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data || []);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  const getYuvaData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/internship/studentadmappl", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setYuvaData(response.data || []);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  const deleteAdmininternship = (data) => {
    console.log("data:", data);
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.position} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/internship/deleteadminternshipappl/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire("Deleted!", "Blog has been deleted.", "success");
                getYuvaData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  const deleteIndustryinternship = (data) => {
    console.log("data:", data);
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.position} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/internship/deleteindinternshipappl/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire("Deleted!", "Blog has been deleted.", "success");
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  return (
    <>
      <h3 className="text-center my-3">Internship Applications</h3>
      <div className="container" style={{ overflowX: "scroll" }}>
        <table className="table table-striped border">
          <thead>
            <tr>
              <th scope="col">Sr. No.</th>
              <th scope="col">Position</th>
              <th scope="col">Company Name</th>
              <th scope="col">Internship Description</th>
              <th scope="col">Openings</th>
              <th scope="col">Address</th>
              <th scope="col">Mode</th>
              <th scope="col">Covering Letter</th>
              {/* <th scope="col">Status</th> */}
              <th scope="col">View Resume</th>
              <th scope="col">Delete</th>
            </tr>
          </thead>
          {/* <tbody>
            {Array.isArray(data) && data.length > 0 ? (
              data?.map((item, index) => (
                <tr key={item.id}>
                  <th scope="row">{index + 1}</th>
                  <td>{item.position}</td>
                  <td>{item.company_name}</td>
                  <td>{item.internship_description}</td>
                  <td>{item.address}</td>
                  <td>{item.internship_mode}</td>
                  <td>
                    <a href={item.images} target="_blank">
                      View
                    </a>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No internship applications available.
                </td>
              </tr>
            )}
          </tbody> */}

          <tbody>
            {Array.isArray(data) && data.length > 0
              ? data?.map((item, index) => (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.position}</td>
                    <td>{item.company_name}</td>
                    <td>{item.internship_description}</td>
                    <td>{item.noofposition}</td>
                    <td>{item.address}</td>
                    <td>{item.internship_mode}</td>
                    <td>{item.letter_description}</td>
                    <td>
                      <a href={item.images} target="_blank">
                        view
                      </a>
                    </td>
                    <td>
                      <div className="btn banner text-white">
                        <AiFillDelete
                          onClick={() => deleteIndustryinternship(item)}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              : ""}

            {Array.isArray(yuvadata) && yuvadata.length > 0
              ? yuvadata.map((item, index) => (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.position}</td>
                    <td>{item.company_name}</td>
                    <td>{item.internship_description}</td>
                    <td>{item.noofposition}</td>
                    <td>{item.address}</td>
                    <td>{item.internship_mode}</td>
                    <td>{item.letter_description}</td>
                    <td>
                      <a href={item.images} target="_blank">
                        view
                      </a>
                    </td>
                    <td>
                      <div className="btn banner text-white">
                        <AiFillDelete
                          onClick={() => deleteAdmininternship(item)}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              : ""}
          </tbody>
        </table>
      </div>
    </>
  );
};

// {Array.isArray(data) && data.length > 0 ? (
//   data?.map((item, index) => (

//   ))
// ) : (
//   <tr>
//     <td colSpan="7" className="text-center">
//       No internship applications available.
//     </td>
//   </tr>
// )}

export default StudentInternshipApplications;
